// General
import "./emoji-element.scss";
// Static Data
import livestreamingConst from "../../../../../const/livestreamingConst";
// i18next
import { useTranslation } from "react-i18next";
// Components
import CustomAvatar from "../../custom-avatar/custom-avatar";

const EmojiElement = (props) => {
  const {
    livestreamingAchievementBadge,
    profilePhoto,
    username,
    levellingBadge,
    emoji,

    // Style
    font = livestreamingConst.config.emojiElement.font,
    textColor = livestreamingConst.config.emojiElement.mobileFontColor,
    backgroundColor = "none",

    // Testing Style
    border = "none",
    borderRadius = "0px",
    textStroke = "unset",
    textShadow = "none",

    // Utility
    profileBorder,
  } = props;

  // i18next variables
  const { t } = useTranslation();

  return (
    <div
      id="chat-section-emoji-element-subcomponent"
      style={{
        border: border,
        borderRadius: borderRadius,
        WebkitTextStroke: textStroke,
        textShadow: textShadow,
        background: backgroundColor,
      }}
    >
      <div className="profile-picture-container">
        <CustomAvatar
          className="profile-picture"
          src={profilePhoto}
          profileBorder={profileBorder}
        />
      </div>

      <div className="chat-info-container">
        {livestreamingAchievementBadge?.length > 0 && (
          <div className="livestreaming-achievement-badge-container">
            {livestreamingAchievementBadge?.map((badge, index) => (
              <img
                className="livestreaming-achievement-badge"
                src={badge?.url}
                alt={badge?.type}
                key={index}
              />
            ))}
          </div>
        )}

        <div className="username" style={{ font: font, color: textColor }}>
          {username || "-"}
        </div>

        {levellingBadge && (
          <div className="levelling-badge-container">
            <img
              className="levelling-badge"
              src={levellingBadge}
              alt="levelling-badge"
            />
          </div>
        )}

        <div
          className="emoji-icon-container"
          style={{ font: font, color: textColor }}
        >
          {t("pusher.sent_a_emoji", { emoji: emoji })}
        </div>
      </div>
    </div>
  );
};

export default EmojiElement;
